
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voucher",
      function () {
        return require("private-next-pages/voucher/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/voucher"])
      });
    }
  